/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios/index'
import moment from 'moment-timezone'
import { campaignModule } from "./modules/campaign";
import { stashboardMediaModule } from "./modules/stashboardMedia";
import { store as sbStore } from "@springbig/sb-components";

Vue.use(Vuex)

const state = {
  alerts: {},
  route: null,
  allowBlockBlacklist: false,
  blacklistedTerms: [],
  currentMerchant: {},
  currentUser: {},
  classicEmojiAlertMessage: "we've detected emoji / special character use in this message - that's awesome! heads up " +
    "though, once an emoji / special character is included in a message, you only have 67 characters per credit, not " +
    "160. most emojis are 1 character, but some can be more - so keep an eye out",
  emojiAlertMessage: "we’ve detected emoji / special character use in this message - that’s awesome! heads up though, most emojis are 1 character, but some can be more - so keep an eye out",
  errors: {},
  maxMmsImageSize: 1024 * 1024 * 5, // 5 mb
  maxMediaSize: 1024 * 1024 * 5, // 5 mb
  maxMmsImageResizeWidth: 640, // if image's width is less than or equal to this, dont resize
  modalMetadata: null,
  noUserInteractions: {},
  substitutions: []
}

function metaHasValue(merchant, key, value) {
  if(!merchant || !merchant.metas) {
    return false;
  }

  const meta = merchant.metas.find((meta) => meta.title === key);
  if(!meta) return false;
  return meta.message === value;
}

export const actions = {
  LOAD_ALLOW_BLOCK_BLACKLIST: function ({ dispatch }, { baseUrl }) {
    const url = `${baseUrl}/allow_block`,
      alertKey = 'blacklistAllow',
      commitStateKey = 'allowBlockBlacklistData',
      onSuccessCommit = 'SET_ALLOW_BLOCK_BLACKLIST'
    dispatch('LOAD_ENDPOINT', { url, commitStateKey, onSuccessCommit, alertKey })
  },

  LOAD_CAMPAIGN_CONFIGURATION: function ({ dispatch }) {
    const url = '/api/v3/campaign_configuration',
      alertKey = 'campaignConfig',
      commitStateKey = 'campaignConfig',
      onSuccessCommit = 'SET_CAMPAIGN_CONFIGURATION'
    dispatch('LOAD_ALLOW_BLOCK_BLACKLIST', { baseUrl: url })
    dispatch('LOAD_ENDPOINT', { url, commitStateKey, onSuccessCommit, alertKey })
  },

  LOAD_CURRENT_MERCHANT: function ({ dispatch }) {
    const url = '/api/v3/current_merchant',
      alertKey = 'merchant',
      commitStateKey = 'currentMerchant',
      onSuccessCommit = 'SET_CURRENT_MERCHANT'
    return dispatch('LOAD_ENDPOINT', { url, commitStateKey, onSuccessCommit, alertKey })
  },

  LOAD_CURRENT_USER: function ({ dispatch }) {
    const url = '/api/v3/current_user',
      alertKey = 'user',
      commitStateKey = 'currentUser',
      onSuccessCommit = 'SET_CURRENT_USER'
    dispatch('LOAD_ENDPOINT', {url, commitStateKey, onSuccessCommit, alertKey})
  },

  LOAD_ENDPOINT: function ({ commit }, { method = 'get', url, commitStateKey, onSuccessCommit, alertKey, params }) {
    const stateKey = 'alerts',
      itemKey = alertKey || commitStateKey
    return axios[method](url, params)
      .then((response) => {
        commit('SET_STATE_OBJECT', { stateKey, itemKey, itemObject: {} })
        commit(onSuccessCommit, { [commitStateKey]: response.data })
      })
      .catch((error) => {
        let errorAlert = {
          extraClasses: 'error-alert',
          message: `issue loading ${alertKey}: ${error}`
        }
        commit('SET_STATE_OBJECT', { stateKey, itemKey, itemObject: errorAlert })
      })
  },

  UPDATE_STATE_OBJECT: function ({ commit }, { stateKey = 'errors', itemKey, itemObject }) {
    commit('SET_STATE_OBJECT', { stateKey, itemKey, itemObject })
  },

  DISPLAYING_MODAL: function({ commit }, modalMetadata) {
    commit('SET_MODAL_METADATA', modalMetadata)
  }
}

export const mutations =  {
  RESET_ALERTS: function (state) {
    state.alerts = {}
  },

  SET_ALLOW_BLOCK_BLACKLIST: function (state, { allowBlockBlacklistData }) {
    state.allowBlockBlacklist = allowBlockBlacklistData?.allow_block
  },

  SET_CAMPAIGN_CONFIGURATION: function (state, { campaignConfig }) {
    state.blacklistedTerms = campaignConfig.blacklist_terms
    state.substitutions = campaignConfig.substitutions
  },

  SET_CURRENT_MERCHANT: function (state, { currentMerchant }) {
    state.currentMerchant = currentMerchant
  },

  SET_CURRENT_USER: function (state, { currentUser }) {
    state.currentUser = currentUser
  },

  SET_STATE_OBJECT: function (state, { stateKey, itemKey, itemObject }) {
    const noItemObjectKeys = Object.keys(itemObject).length < 1,
      stateItem = state[stateKey]
    if (noItemObjectKeys && !stateItem[itemKey]) {
      Vue.delete(stateItem, itemKey, itemObject)
    } else if (noItemObjectKeys && stateItem[itemKey]) {
      Vue.delete(stateItem, itemKey, itemObject)
    } else {
      Vue.set(stateItem, itemKey, itemObject)
    }
  },

  SET_MODAL_METADATA: function(state, modalMetadata) {
    state.modalMetadata = modalMetadata
  },

  SET_ROUTE(state, route) {
    state.route = route;
  }
}

export const getters = {
  currentMerchant(state) {
    return state.currentMerchant;
  },

  currentMerchantTime: function (state) {
    if (state.currentMerchant?.merchant_time_zone) {
      return moment.tz(moment(), state.currentMerchant.merchant_time_zone).format('hh:mma')
    }
  },

  merchantCountryIsCanada: function (state) {
    // TODO probably better to have this be "not US"
    return state.currentMerchant?.country === 'CA'
  },

  merchantTimeZone: function (state) {
    return state.currentMerchant?.merchant_time_zone
  },

  showFiltersAlert: function (state) {
    return state.currentMerchant.show_filters_alert
  },

  userAbilitiesValue: function (state) {
    if(!state.currentUser?.user_permissions) {
      return null
    } else {
      return BigInt(state.currentUser?.user_permissions)
    }
  },

  modalMetadataFor: (state) => (name, module) => {
    if(state.modalMetadata?.name !== name) { return null }
    if(module && state.modalMetadata?.module !== module) { return null }
    return state.modalMetadata
  },

  classicCampaignsEnabled(state) {
    return metaHasValue(state.currentMerchant, 'skip_stashboard', '1');
  },

  newEmojiCalculationTypeEnabled(state) {
    return state.currentMerchant.emoji_calculation_type === 'new';
  },

  useCampaignEditor2(state) {
    return metaHasValue(state.currentMerchant, 'use_campaign2', '1');
  },

  hasNotificationMmsMetaEnabled(state) {
    return metaHasValue(state.currentMerchant, 'notification_mms', '1');
  },

  advancedSegmentEnabled(state) {
    return metaHasValue(state.currentMerchant, 'advanced_segment', '1');
  },

  hasLoyaltyByLocationMetaEnabled(state) {
    return metaHasValue(state.currentMerchant, 'loyalty_by_location_enabled', '1');
  },

  hasCheckinReasonEnabled(state){
    return metaHasValue(state.currentMerchant, 'checkin_reasons', '1');
  }
}

export const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    campaign: campaignModule,
    stashboardMedia: stashboardMediaModule,
    sbComponents: sbStore
  }
});
